// extracted by mini-css-extract-plugin
export default {"container":"PZ-z","list":"QZ-z"};